import {create} from 'zustand';

interface ContractTableFiltersAddModalState {
  open: boolean;

  contractTableFiltersAddModalOpen: () => void;
  contractTableFiltersAddModalClose: () => void;
}

export const useContractTableFiltersAddModalStore = create<ContractTableFiltersAddModalState>((set, get) => ({
  open: false,

  contractTableFiltersAddModalOpen: () => set({open: true}),
  contractTableFiltersAddModalClose: () => set({open: false}),
}));

export const {contractTableFiltersAddModalOpen, contractTableFiltersAddModalClose} =
  useContractTableFiltersAddModalStore.getState();
